export const COPY_TO_CLIPBOARD = 'app/COPY_TO_CLIPBOARD';
